// extracted by mini-css-extract-plugin
export default {"active":"style--active--c7c740","right":"style--right--d75bf0","centered":"style--centered--710169","centeredVertically":"style--centeredVertically--b9ecb3"};